import { useState } from 'react';
import { PassFrontScreen } from './screens/PassFrontScreen';
import { MatchInfoScreen } from './screens/MatchInfoScreen';
import { EventGuideScreen } from './screens/EventGuideScreen';
import { VenueMapScreen } from './screens/VenueMapScreen';

export type DemoScreen = 'passFront' | 'matchInfo' | 'eventGuide' | 'venueMap';

const ApplePosterDemo = () => {
  const [screen, setScreen] = useState<DemoScreen>('passFront');
  const backToPassFront = () => setScreen('passFront');

  return (
    <>
      {screen === 'passFront' && <PassFrontScreen onNavigate={setScreen} />}
      {screen === 'matchInfo' && <MatchInfoScreen onBack={backToPassFront} />}
      {screen === 'eventGuide' && (
        <EventGuideScreen onBack={backToPassFront} onNavigate={setScreen} />
      )}
      {screen === 'venueMap' && (
        <VenueMapScreen onBack={() => setScreen('eventGuide')} />
      )}
    </>
  );
};

export default ApplePosterDemo;
